export default __webpack_public_path__ + "static/media/GUI.4747aac7.svg";